import * as Queries from './queries';
import * as Mutations from './mutations';
import * as UpdatedQueries from './updatedQueries';

/**
 * @deprecated Move queries to graphql/operations for better type checking. See /docs/typedQueries for more information.
 */
export default { Queries, Mutations, UpdatedQueries };
